var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineChartFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.5H3.66667V15.8333H18.6667V17.5H2.83333C2.3731 17.5 2 17.1269 2 16.6667V2.5Z",
    fill: "#2E1C65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5564 10.7725L18.684 5.08265L16.9828 3.25067L12.0322 7.8477L10.0893 5.90482C9.76388 5.57936 9.23625 5.57936 8.91084 5.90482L4.86621 9.94945L6.63396 11.7172L9.50009 8.85111L11.4001 10.7511C11.717 11.0681 12.228 11.0775 12.5564 10.7725Z",
    fill: "#2E1C65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartFill);
export default __webpack_public_path__ + "static/media/line_chart_fill.2bd43728b98b0e9392449b034c5f0b24.svg";
export { ForwardRef as ReactComponent };